import { InlineLink, TextBase, TooltipBubble } from '@carboncopyco/ui';
import { formatPlural } from '@carboncopyco/utils';
import { useBoolean } from 'ahooks';
import { ViewedScreensModal } from './ScreensModal';

type ViewedScreensProps = {
  sessionId: string;
  workspaceId: string;
  organizationId: string;
  screensVisited: number;
  isOverlay?: boolean;
};

export const ViewedScreens = ({
  sessionId,
  workspaceId,
  organizationId,
  isOverlay,
  screensVisited,
}: ViewedScreensProps) => {
  const [
    showScreensModal,
    { setTrue: setTrueShowScreensModal, setFalse: setFalseShowScreensModal },
  ] = useBoolean(false);

  if (!screensVisited) {
    return (
      <TooltipBubble
        title="Not viewed yet"
        placement="top"
      >
        <TextBase label="-" />
      </TooltipBubble>
    );
  }

  return (
    <>
      <TooltipBubble
        title={`${screensVisited} viewed ${formatPlural('screen', screensVisited)}`}
        placement="top"
      >
        {isOverlay ? (
          <TextBase
            label={screensVisited}
            color="text-ds-natural-600"
          />
        ) : (
          <InlineLink
            as="button"
            label={screensVisited}
            onClick={setTrueShowScreensModal}
          />
        )}
      </TooltipBubble>
      {showScreensModal && (
        <ViewedScreensModal
          open={showScreensModal}
          onClose={setFalseShowScreensModal}
          organizationId={organizationId}
          workspaceId={workspaceId}
          sessionId={sessionId}
        />
      )}
    </>
  );
};
